export default "__VITE_ASSET__vfsjLirg__"